import module from 'finanzas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('finances.reportecomisiones', {
    url: '/reportecomisiones?{comisionistas}&{proveedores}&{clientes}&{fechaInicial:date}&{fechaFinal:date}',
    params: {comisionistas: {array: true}, proveedores: {array: true}, clientes: {array: true}},
    data: {title: 'Reporte de comisiones'},
    template: '<finanzas-reportecomisiones busqueda="$params"></finanzas-reportecomisiones>',
    controller ($scope, $stateParams) {
      $scope.$params = $stateParams
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/reportecomisiones/routes/finanzas-reportecomisiones.js